import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface GeneralResponse {
    data: GeneralResponseBody;
    errors?: Array<string>;
}
export interface DocumentTypeType {
    id: string;
    code: string;
}
export interface GeneralResponseBody {
    data: Array<DocumentTypeType>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}
export interface DocumentTypePayload {
    policyTypeCode: string;
    claimCategoryCode: string;
    formTypeCode: string;
}
export const fetchDocumentTypes = createAction<
    fetchDocumentTypesAction | undefined
>(ActionTypes.FETCH_DOCUMENT_TYPES);
export const fetchDocumentTypesSuccess =
    createAction<fetchDocumentTypesSuccessAction>(
        ActionTypes.FETCH_DOCUMENT_TYPES_SUCCESS,
    );
export const fetchDocumentTypesFailed =
    createAction<fetchDocumentTypesFailedAction>(
        ActionTypes.FETCH_DOCUMENT_TYPES_FAILED,
    );

export interface fetchDocumentTypesAction {
    type: typeof ActionTypes.FETCH_DOCUMENT_TYPES;
    payload: DocumentTypePayload;
}

export interface fetchDocumentTypesSuccessAction {
    type: typeof ActionTypes.FETCH_DOCUMENT_TYPES_SUCCESS;
    body: GeneralResponse;
}

export interface fetchDocumentTypesFailedAction {
    type: typeof ActionTypes.FETCH_DOCUMENT_TYPES_FAILED;
    body: GeneralResponse;
}
